var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCreate)?_c('Create',{attrs:{"value":_vm.value,"mode":_vm.mode}}):_c('CruResource',{attrs:{"resource":_vm.value,"mode":_vm.realMode},on:{"finish":_vm.finish}},[_c('Config',{attrs:{"value":_vm.value,"mode":_vm.mode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }